import React from 'react'
import { MobileMenuHeaderProps } from '../ContentfulNavigation'
import useWindowSize from '@toasttab/shared/src/hooks/useWindowSize'
import classNames from 'classnames'

const MobileMenuHeader = ({
  handleBackButton,
  handleCloseButton,
  showOnTablet,
  title
}: MobileMenuHeaderProps) => {
  const windowSize = useWindowSize()
  const isMobileLayout = windowSize.width < 1024
  const headerClasses = classNames(
    'flex flex-nowrap justify-between items-center border-b border-gray-25 px-4 py-3',
    {
      'md:hidden': !showOnTablet
    }
  )

  return (
    <div
      aria-hidden={!isMobileLayout}
      className={headerClasses}
      data-testid='MobileMenuHeader'
    >
      <button
        aria-label='Return to Previous Menu'
        className='before:content-icon-chevron-left before:h-6 before:w-6 relative top-1'
        data-testid='MobileMenuHeader-back'
        onClick={handleBackButton}
        tabIndex={!isMobileLayout ? -1 : null}
      />
      <h4 className='font-effra text-[22px] leading-8'>{title}</h4>
      <button
        aria-label='Close Mobile Navigation'
        className='w-5 h-5'
        data-testid='MobileMenuHeader-close'
        onClick={handleCloseButton}
        tabIndex={!isMobileLayout ? -1 : null}
      >
        <span
          aria-hidden='true'
          className='block absolute h-0.5 w-5 bg-gray-125 transform transition duration-500 ease-in-out rotate-45'
        />
        <span
          aria-hidden='true'
          className='block absolute h-0.5 w-5 bg-gray-125 transform transition duration-500 ease-in-out opacity-0'
        />
        <span
          aria-hidden='true'
          className='block absolute h-0.5 w-5 bg-gray-125 transform transition duration-500 ease-in-out -rotate-45'
        />
      </button>
    </div>
  )
}

export default MobileMenuHeader
